// Promise简化
to = function (promise) {
  return promise.then(data => {
    return [null, data]
  })
    .catch(err => [err])
}

// 操作常量对象
// 通过value获取key
findKey = function (obj, value, compare = (a, b) => a === b) {
  return Object.keys(obj).find(k => compare(obj[k], value))
}

// 获取key数组
getObjectKeys = function (object) {
  var keys = []
  for (var property in object) keys.push(property)
  return keys
}

// 获取value数组
getObjectValues = function (object) {
  var values = []
  for (var property in object) values.push(object[property])
  return values
}

// 校验手机号
isPhoneNumber = (number) => {
  const mobileReg = /^1[3456789]\d{9}$/
  return mobileReg.test(number)
}

http:// test.bajiesleep.com/children/h5/?taskID=170
// 获取浏览器地址栏中URL字符串
getURLData = () => {
  const tempStr = window.location.href
  // let tempStr = "http://cloud.bajiesleep.com/children/h5/?taskID=391"

  // 获取URL中携带的信息对象
  const tempArr = tempStr.split('?')[1] ? tempStr.split('?')[1].split('&') : []
  const returnArr = {}
  tempArr.forEach(element => {
    returnArr[element.split('=')[0]] = element.split('=')[1]
  })
  return returnArr
}

dataURItoBlob = (base64Data) => {
  var byteString;
  if (base64Data.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(base64Data.split(',')[1]);
  else
    byteString = unescape(base64Data.split(',')[1]);
  var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], { type: mimeString });
}
